<template>
  <div class="h-full overflow-x-auto overflow-y-auto">
    <!-- 表格头部 -->
    <div class="sticky top-0 bg-white dark:bg-gray-800 z-10 border-b border-gray-200 dark:border-gray-700">
      <div class="flex min-w-[1080px]">
        <div class="w-16 py-3.5 px-3 text-left text-sm font-semibold text-gray-900 dark:text-gray-100">ID</div>
        <div class="flex-1 px-3 py-3.5 text-left text-sm font-semibold text-gray-900 dark:text-gray-100">试卷标题</div>
        <div class="w-40 px-3 py-3.5 text-left text-sm font-semibold text-gray-900 dark:text-gray-100">所属书籍</div>
        <div class="w-32 px-3 py-3.5 text-center text-sm font-semibold text-gray-900 dark:text-gray-100">考试日期</div>
        <div class="w-24 px-3 py-3.5 text-center text-sm font-semibold text-gray-900 dark:text-gray-100">类型</div>
        <div class="w-24 px-3 py-3.5 text-center text-sm font-semibold text-gray-900 dark:text-gray-100">付费状态</div>
        <div class="w-36 px-3 py-3.5 text-center text-sm font-semibold text-gray-900 dark:text-gray-100">操作</div>
      </div>
    </div>

    <!-- 表格内容 -->
    <div class="divide-y divide-gray-200 dark:divide-gray-700">
      <div v-for="paper in papers" :key="paper.id" class="flex items-center min-w-[1080px] hover:bg-indigo-50 dark:hover:bg-indigo-900/30">
        <div class="w-16 py-4 px-3 text-sm text-gray-900 dark:text-gray-100">{{ paper.id }}</div>
        <div class="flex-1 px-3 py-4 text-sm text-gray-900 dark:text-gray-100">{{ paper.title }}</div>
        <div class="w-40 px-3 py-4 text-sm text-gray-900 dark:text-gray-100">{{ getBookLabel(paper) }}</div>
        <div class="w-32 px-3 py-4 text-sm text-center text-gray-900 dark:text-gray-100">{{ paper.testDate }}</div>
        <div class="w-24 px-3 py-4 text-sm text-center text-gray-900 dark:text-gray-100">{{ formatPaperType(paper.type) }}</div>
        <div class="w-24 px-3 py-4 text-sm flex justify-center">
          <span class="px-2 py-1 text-xs font-semibold rounded-full"
            :class="paper.isPremium ? 'bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-400' : 'bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-300'">
            {{ paper.isPremium ? '付费' : '免费' }}
          </span>
        </div>
        <div class="w-36 px-3 py-4 text-sm">
          <div class="flex items-center justify-center gap-3">
            <button @click="handleEditContent(paper)" class="link-btn-view">
              编辑内容
            </button>
            <button @click="handleEdit(paper)" class="link-btn-edit">
              编辑
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- 空状态 -->
    <div v-if="papers.length === 0" class="text-center py-12 text-gray-500 dark:text-gray-400">
      暂无试卷数据
    </div>
  </div>
</template>

<script setup lang="ts">
import type { Paper } from '@/types/mock/paper'

/**
 * Props
 */
interface Props {
  /** 试卷列表 */
  papers: Paper[]
}

defineProps<Props>()

/**
 * Emits
 */
interface Emits {
  /** 编辑试卷 */
  (e: 'edit', paper: Paper): void
  /** 编辑试卷内容 */
  (e: 'edit-content', paper: Paper): void
}

const emit = defineEmits<Emits>()

/**
 * 处理编辑按钮点击
 *
 * @param paper 试卷对象
 */
const handleEdit = (paper: Paper) => {
  emit('edit', paper)
}

const handleEditContent = (paper: Paper) => {
  emit('edit-content', paper)
}

const getBookLabel = (paper: Paper) => {
  return paper.book?.displayName || paper.book?.name || '-'
}

const formatPaperType = (type: Paper['type']) => {
  if (type === 'academic') {
    return 'Academic'
  }
  if (type === 'general') {
    return 'General'
  }
  return type
}
</script>
